import { omit } from 'lodash'
import { DriverRegistrationRequest, ThumbType } from '~/shared/api'
import { IdentityRecognitionFileEnum } from '~/shared/config/enums'

export const uploadPhoto = async (
  blob: Blob,
  taxiparkId?: UniqueId,
): Promise<ThumbType> => {
  const uuid = await DriverRegistrationRequest.uploadMedia(blob, taxiparkId)
  const url = URL.createObjectURL(blob)

  return {
    uuid,
    previewUrlDownload: url,
    originalUrlDownload: url,
  }
}

export const omitValidationFields = <T extends Record<string, unknown>>(
  data: T,
): Omit<T, 'isIndividualEntrepreneur'> => {
  return omit(data, ['isIndividualEntrepreneur'])
}

export const filteredDocumentsForRecognition = (
  documents: ThumbType[] | string[],
  types: IdentityRecognitionFileEnum[],
) => {
  return documents
    .filter(
      (doc): doc is ThumbType =>
        typeof doc !== 'string' &&
        types.includes(doc.type as IdentityRecognitionFileEnum),
    )
    .map((doc) => ({
      uuid: doc.uuid,
      type: doc.type as IdentityRecognitionFileEnum,
    }))
}

export const haveSameFiles = (a: string[], b: string[]) => {
  if (a.length !== b.length) return false
  const setA = new Set(a)
  return b.every((id) => setA.has(id))
}
